'use strict';

import register from './core';
import '../functions/jquery-global';
import { getCurrentPageHeaderInfo } from '../functions/common'; // TODO: Use this function to the new accordion stuff to

register('accordion', function (element) {
  var accordionId = element.getAttribute('aria-controls'),
    hasHeading = $(element).parent().hasClass('text--accordion-heading');

  if (!accordionId)
    return;

  var $accordion = $(`[data-id="${accordionId}"]`);

  if (!$accordion)
    return;

  var $accButton = $(element);
  var $closeButton = $accButton.parent().find('.js-accordion-close-button');

  function toggleExpanded(setExpanded, usePushState, useScrollTo) {
    function getScrollTop() {
      var $accordionScrollTo = $(`[data-scrollto="${accordionId}"]`);
      var offset = getCurrentPageHeaderInfo().totalHeight;
      return parseInt($accordionScrollTo.position().top + offset);
    }

    function complete() {
      $accButton.attr('aria-expanded', setExpanded ? 'true' : 'false');
      if (usePushState && history.replaceState)
        history.replaceState(null, null, setExpanded ? '#' + accordionId : window.location.href.replace(/#.*/g, '')); // NOTE: Need to do like this to support Edge and IE

      if (useScrollTo)
        $('html, body').animate({ scrollTop: getScrollTop() });
    }

    if (setExpanded)
      $accordion.slideDown({ complete: complete });
    else
      $accordion.slideUp({ complete: complete });
  }

  function accClose(useScrollTo) {
    $accButton.focus();
    $accButton.attr("data-whatinput", "keyboard");
    toggleExpanded(false, true, useScrollTo);
  }

  if ($accordion.parent().hasClass('search-block--accordion-compactlist') || $accordion.parent().hasClass('search-block--accordion-compact')) {
    if ($accordion.find('ul.list__list')) {
      var listCount = $accordion.find('ul.list__list').children('li.list__item').length;
      var openByDefault = $(element).attr('data-open-by-default');

      let maxListCount = 7;
      const maxListCountAttr = $(element).attr('data-max-list-count');

      if (maxListCountAttr)
        maxListCount = parseInt(maxListCountAttr);

      if (listCount <= maxListCount && openByDefault)
        toggleExpanded(true, false, false);
    }
  }
  //removed opening accordion by default
  $accButton.on('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if ($accButton.attr('aria-expanded') !== 'true') {

      if (hasHeading) {
        // 25 seems to be the line-height (roughly), so moves the title element up the
        // same amount of lines as the button label.
        // Changed to also account for the padding of the button (15 px).
        var lines = $(element).find('.text__button-label').first().innerHeight() / 25;
        $accordion.find('.text__title').first().css('margin-top', lines * -25 - 15);
      }

      $accButton.data('offset', window.pageYOffset);
      toggleExpanded(true, true, false);
    }
    else
      accClose(false);
  });

  $closeButton.on('click', function (e) {
    accClose(true);
  });

  $(document).ready(function () {
    if (location.hash.substr(1) === accordionId)
      toggleExpanded(true, true, true);
  });

  //jack into form submit event and scroll to start of accordion
  if (typeof $$epiforms !== 'undefined') {
    $$epiforms(document).ready(function myfunction() {
      $$epiforms(".EPiServerForms").on("formsSubmitted",
        function (event, param1, param2) {
          $('html, body').animate({
            scrollTop: $accordion.prev().data('offset')
          });
        });
    });
  }
});
